import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "../../Subcomponents/Button";
import cssClasses from "./EMandate.module.css";
import {
  Card,
  Divider,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
} from "@mui/material";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { useNavigate } from "react-router-dom";

import BankVerification from "./BankVerification";
// import EMandate from "./EMandate";
import ConfirmPaymentSchedule from "./ConfirmPaymentSchedule";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { useEffect } from "react";
import axios from "axios";
import SingleApplicant from "./SingleApplicant";

// 🔹 Back button style (used in both sections)
const backBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#ffffff",
  color: "#0f172a",
  boxShadow: "none",
  fontSize: "1.52rem",
};


const SplitOption = ({ allotment, totalAmount, allotmentPaymentId, totalMandateAmount, bookingId }) => {


  const navigate = useNavigate();
  const dispatch = useDispatch();


  const handleOpenEMandate = () => {
    // navigate("/Home/EMandate", {
    //   state: {
    //     // allotment: allotmentDetail.current,
    //     edit: true,
    //   },
    // });
    // initiateMandate();
  };

  const handleBackToAllotments = () => {
    navigate("/Home/EMandate", {
      // state: {
      //   // allotment: allotmentDetail.current,
      //   edit: true,
      // },
    });
  };

  const handleSplitAmount = () => {
  navigate("/Home/SplitAmount", {
    state: {
      allotment,
      totalAmount,
      totalMandateAmount,
      bookingId,
      allotmentPaymentId, // ✅ IMPORTANT
    },
  });
};


  // const handleSingleApplicant = () => {
  //   console.log("EMandateSplit totalAmount:", totalAmount);
  //   navigate("/Home/SingleApplicant", {
  //     state: {
  //       totalAmount,
  //       allotment,
  //     },
  //   });
  // };
  const handleSingleApplicant = () => {
  navigate("/Home/SingleApplicant", {
    state: {
      allotment,
      totalAmount,
      totalMandateAmount,
      bookingId,
      allotmentPaymentId, // ✅ IMPORTANT
    },
  });
};


  return (
    <div className={cssClasses.wrapper}>
      <div className={cssClasses.header}>
        <h2>E-Mandate Split Option</h2>
        <p>Choose how to distribute the mandate between the applicants.</p>
      </div>

      <Card className={cssClasses.amountCard} elevation={0}>
        <span>Total Mandate Amount</span>
        <strong>₹{numberWithCommas(totalMandateAmount)}</strong>
      </Card>

      {/* 🔹 REQUIRED INFO BOX */}
      <div className={cssClasses.infoBox}>
        <span className={cssClasses.infoIcon}>
          {" "}
          <PeopleOutlineIcon sx={{ fontSize: 22, color: "#26A98F" }} />
        </span>
        <p>Do you want to split the E-Mandate amount between applicants?</p>
      </div>

      {/* 🔹 ACTION CARDS */}
      <div className={cssClasses.actionRow}>
        <div className={cssClasses.splitBtn} onClick={handleSplitAmount}>
          <PeopleOutlineIcon sx={{ fontSize: 22 }} />
          <span>Yes, Split Amount</span>
        </div>

        <div className={cssClasses.splitBtn} onClick={handleSingleApplicant}>
          <CheckCircleOutlineIcon sx={{ fontSize: 22 }} />
          <span>No, Single Applicant</span>
        </div>
      </div>

      <Button
        btnName="Back to Allotments"
        style={backBtnStyle}
        // clicked={() => setActiveStep(0)}
        clicked={handleBackToAllotments}
      />
    </div>
  );
};

const cardStyle = {
  height: "80px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#fff",
};

export default SplitOption;
